import styled from 'styled-components'

export const FormTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding: 8px;
  color: var(--grey);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 18px;
    padding-top: 16px;
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.div<{ hasIcon: boolean }>`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding: 8px;
  color: var(--primary);
  text-align: center;
  border-bottom: 4px solid var(--primary);
  display: flex;
  align-items: center;
  justify-content: ${({ hasIcon }) => (hasIcon ? 'flex-start' : 'center')};

  span {
    margin-left: ${({ hasIcon }) => (hasIcon ? 'auto' : '0')};
    margin-right: ${({ hasIcon }) => (hasIcon ? 'auto' : '0')};
  }

  a {
    color: var(--primary);
    text-decoration: none;
    margin-right: 1rem;
  }

  @media (max-width: 768px) {
    && {
      font-size: 14px;

      span {
        font-size: 14px;
      }
    }
  }
`

export const StepTransition = styled.div`
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: 1;
  transform: translateX(0);
  min-height: 200px;

  &.exit {
    opacity: 0;
    transform: translateX(-100%);
  }

  &:not(.exit) {
    opacity: 1;
    transform: translateX(0);
  }
`

export const StepButtonsWrapper = styled.div`
  display: flex;
  justify-content: ${props => props.className?.includes('center') ? 'center' : 'flex-end'};
  margin-top: 1rem;
  width: 100%;
`

export const NextButton = styled.button.attrs<{ isRegister?: boolean }>((props) => ({
  'data-is-register': props.isRegister ? 'true' : 'false'
})) <{ isRegister?: boolean }>`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: 1px solid var(--primary);
  background-color: ${props => {
    if (props.isRegister) {
      if (props.disabled) return '#0066B3'
      return '#0066B3'
    }
    if (props.disabled) return 'var(--grey-light)'
    return 'var(--white)'
  }} !important;
  color: ${props => {
    if (props.isRegister) {
      if (props.disabled) return '#FFFFFF'
      return '#FFFFFF'
    }
    if (props.disabled) return 'var(--grey)'
    return 'var(--primary)'
  }} !important;
  opacity: ${props => props.disabled && !props.isRegister ? 0.6 : 1};
  padding: 12px 16px;
  gap: 8px;
  font-family: sans-serif;
  font-weight: 700;
  font-size: ${props => props.isRegister ? '16px' : '18px'};
  line-height: 140%;
  text-align: center;
  vertical-align: middle;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &[data-is-register="true"] {
    background-color: #0066B3 !important;
    color: #FFFFFF !important;
    border-color: #0066B3 !important;
  }

  &[data-is-register="true"]:disabled {
    background-color: #0066B3 !important;
    color: #FFFFFF !important;
    border-color: #0066B3 !important;
    opacity: 0.6;
    cursor: not-allowed;
  }

  &[data-is-register="true"]:not(:disabled):hover {
    background-color: #00477d !important;
    border-color: #00477d !important;
    color: #FFFFFF !important;
    opacity: 1;
  }

  &[data-is-register="true"]:not(:disabled):active {
    background-color: #00477d !important;
    border-color: #00477d !important;
    color: #FFFFFF !important;
    opacity: 1;
  }

  &:hover:not(:disabled) {
    background-color: ${props => props.isRegister ? 'var(--primary-dark)' : 'var(--primary-light)'};
    border-color: ${props => props.isRegister ? 'var(--primary-dark)' : 'var(--primary)'};
  }

  &:active:not(:disabled) {
    background-color: ${props => props.isRegister ? 'var(--primary-dark)' : 'var(--primary-light)'};
    border-color: ${props => props.isRegister ? 'var(--primary-dark)' : 'var(--primary)'};
  }
`

export const PasswordAcceptance = styled.div<{ isInvalid: boolean }>`
  color: ${({ isInvalid }) => (isInvalid ? 'var(--danger)' : 'var(--gray-600)')};
  font-size: 0.875rem;
  margin-bottom: 1rem;
`
